import React, { useEffect, useState } from 'react'
import './index.scss'
import { useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import FieldErrorSectionForm from '@App/kit/fields/v2/FieldErrorSectionForm'
import { doesFieldHaveFocus } from '@App/common/utils'
import FormFieldProps from '@App/forms/v2/common/form-field'
import getInputName from '@App/forms/v2/helpers/get-input-name'
import getFormError from '@App/forms/v2/helpers/get-form-error'
import CheckBox from '@Components/Selectors/Checkbox'

const InputTextForm = (props: FormFieldProps) => {
    const { register, watch, formState } = useFormContext()
    const [hasFocus, setFocus] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const { label, mainColor = true, isDisabled, inputType, tooltip } = props

    const inputName = getInputName(props)

    const setFocusIfNotDisabled = (isFocused: boolean) => {
        if (!isDisabled) {
            setFocus(isFocused)
        }
    }

    useEffect(() => {
        setFocus(doesFieldHaveFocus(inputName))
    }, [])

    const fieldValue = watch(inputName)
    const { errors } = formState
    const fieldError = getFormError(props, errors)
    const isPassword = inputType === 'password'
    const actualInputType = isPassword && showPassword ? 'text' : inputType
    const outerDivClassNames = clsx(
        mainColor ? 'main-color-set' : 'second-color-set',
        'input-text-form-component',
        hasFocus && 'focused',
        !!fieldError && 'error',
        isDisabled && 'disabled',
        !!fieldValue && 'filled'
    )

    const depsNames = () => {
        if (props.validationDependency) {
            return props.validationDependency.map(getInputName)
        }
        return []
    }

    const registerResult = register(inputName, {
        deps: depsNames(),
    })

    return (
        <div className={outerDivClassNames} role={`container-${inputName}`}>
            <label className="input-text-form-label" htmlFor={inputName}>
                {label}
                <div className="tooltip-wrapper">{tooltip && tooltip}</div>
            </label>
            <input
                {...registerResult}
                onFocus={() => setFocusIfNotDisabled(true)}
                onBlur={(e) => registerResult.onBlur(e).then(() => setFocusIfNotDisabled(false))}
                id={inputName}
                type={actualInputType}
                disabled={!!isDisabled}
            />
            {isPassword && (
                <CheckBox
                    id="show-password"
                    className="show-password"
                    mainColor
                    onClick={() => setShowPassword(!showPassword)}
                >
                    Show Password
                </CheckBox>
            )}
            <FieldErrorSectionForm {...props} fieldError={fieldError} />
        </div>
    )
}

export default InputTextForm
